import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=9b929efe&scoped=true&"
import script from "./QuickMenu.vue?vue&type=script&lang=js&"
export * from "./QuickMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuickMenu.vue?vue&type=style&index=0&id=9b929efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b929efe",
  null
  
)

export default component.exports